import { ChecklistTemplateRepository } from "../../repositories/ChecklistTemplateRepository";
import { ChecklistTemplateEntity } from "../../entities/ChecklistTemplateEntity";

/**
 * Get Template Use Case
 * Retrieves the active month-end checklist template
 */
export class GetTemplateUseCase {
  constructor(private repository: ChecklistTemplateRepository) {}

  async execute(): Promise<ChecklistTemplateEntity | null> {
    return await this.repository.getTemplate();
  }
}

